import { render, staticRenderFns } from "./ResourceTree.vue?vue&type=template&id=7c050da6&"
import script from "./ResourceTree.vue?vue&type=script&lang=js&"
export * from "./ResourceTree.vue?vue&type=script&lang=js&"
import style0 from "./ResourceTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports